"use client";

import CategoryViewItem from "component/categories-viewer/CategoryViewItem";
import PAImage from "component/design-system/images/PAImage";
import { useTranslation } from "next-i18next";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import styles from "./merchandise-slider.module.scss";

const categoryCards = [
  {
    title: "Air Fresheners",
    subtitle: "Experience freshness with our long-lasting and stylish car air fresheners.",
    img: "/images/apparels/Accessories.webp",
    category: {
      tier0: "Merchandise",
      tier1: "Accessories",
    },
  },
  {
    title: "Car Care & Detailing",
    img: "/images/apparels/Car-Care.webp",
    subtitle: "Keep your car looking fresh with our easy-to-use and extremely effective car care and detailing products",
    category: {
      tier0: "Merchandise",
      tier1: "Car Care & Detailing",
    },
  },
  {
    title: "Men's T-shirts",
    img: "/images/apparels/Men.webp",
    subtitle: "Discover our men's top-quality, breathable, and stylish 100% cotton t-shirts.",
    category: {
      tier0: "Merchandise",
      tier1: "men",
    },
  },
  {
    title: "Women's T-shirts",
    img: "/images/apparels/Women.webp",
    subtitle: "Explore our women's top-quality, breathable, and stylish 100% cotton t-shirts.",
    category: {
      tier0: "Merchandise",
      tier1: "women",
    },
  },
];

function MerchandiseSlider(props) {
  const { imageHeight, imageWidth } = props;
  const { t } = useTranslation("home");
  return (
    <div className={`${styles.cat_grid}`}>
      {categoryCards.map((item) => (
        <CategoryViewItem categoryObj={item.category} defaultFilters={item.defaultFilters} key={item.title}>
          <div className={`${styles.each_grid}`}>
            <div className={`${styles.grid_container}`}>
              <div className={`${styles.text_grid_container}`}>
                <div className={`${styles.apparel_title}`}>{t(item.title)}</div>
                <div className={`${styles.sub_title}`}>{t(item.subtitle)}</div>
              </div>
              <div className={`${styles.icon_container}`}>
                <PAImage
                  src={getRelativeImagePath(item.img)}
                  width={imageWidth || 320}
                  height={imageHeight || 180}
                  className={`${styles.img} ${styles.desktopIcon}`}
                  alt={t("Explore Special Offers on", { title: item.title })}
                  title={t("Explore Special Offers on", { title: item.title })}
                />
              </div>
            </div>
          </div>
        </CategoryViewItem>
      ))}
    </div>
  );
}

export default MerchandiseSlider;
